import { useState } from "react";

import NotEnoughSeats from "features/subscriptions/components/NotEnoughSeats";
import type { MixpanelSubscriptionSource } from "features/subscriptions/types";

import { Dialog } from "common/components/ui/Dialog";
import { Drawer } from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

interface NotEnoughSeatsDialogProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  noSeatAccountIds: string[];
  mixpanelSource: Exclude<MixpanelSubscriptionSource, "billing_page">;
}

export default function NotEnoughSeatsDialog({
  isOpen,
  setIsOpen,
  mixpanelSource,
  noSeatAccountIds,
}: NotEnoughSeatsDialogProps) {
  const isDesktop = useTwBreakpoint("lg");
  const [resetKey, setResetKey] = useState(0);

  const Component = isDesktop ? Dialog : Drawer;

  return (
    <Component
      open={isOpen}
      onOpenChange={setIsOpen}
      onAfterClose={() => setResetKey((k) => k + 1)}
    >
      <NotEnoughSeats
        key={resetKey}
        noSeatAccountIds={noSeatAccountIds}
        mixpanelSource={mixpanelSource}
      />
    </Component>
  );
}
